
window.__lazy_callback__ = function (lazyModule) {
  return class extends React.Component {
    state = {
      component: null,
    }
    componentWillMount() {
      lazyModule((module) => {
        if (typeof module.default === 'function') {
          this.setState({
            component: module.default,
          });
        } else {
          this.setState({
            component: module,
          });
        }
      });
    }
    render() {
      const Comp = this.state.component;
      return Comp ? <Comp {...this.props} /> : <div />;
    }
  };
}

import './assets/css/reset.css';
import './assets/css/style.less';
import './assets/css/detection.less';
import './assets/css/guide.less';

const Box = __lazy_callback__(cb => import(/* webpackChunkName: "component/box/box" */ './component/box/box').then(cb));
const Chrome = __lazy_callback__(cb => import(/* webpackChunkName: "component/chrome/chrome" */ './component/chrome/chrome').then(cb));
const Detection = __lazy_callback__(cb => import(/* webpackChunkName: "component/detection/detection" */ './component/detection/detection').then(cb));
const ShareGuide = __lazy_callback__(cb => import(/* webpackChunkName: "component/guide/shareGuide" */ './component/guide/shareGuide').then(cb));
const Home = __lazy_callback__(cb => import(/* webpackChunkName: "component/home/home" */ './component/home/home').then(cb));
const Medal = __lazy_callback__(cb => import(/* webpackChunkName: "component/medal/medal" */ './component/medal/medal').then(cb));
const Task = __lazy_callback__(cb => import(/* webpackChunkName: "component/task/task" */ './component/task/task').then(cb));
import React, { Component } from 'react';
import { Provider } from 'react-redux';
import {
    Redirect,
    Route,
    HashRouter as Router,
    Switch
} from 'react-router-dom';
import { createStore } from 'redux';

import AuthRouter from './component/common/authRouter';
import Loading from './component/common/loading/loading';
import UserInfor from './component/common/userInfor';
import Store from './store/index';

const store = createStore(Store);

class App extends Component {
    render() {
        return (
            <Router>
                <Provider store={store}>
                    <UserInfor />
                    <Switch>
                        <Route path="/" exact component={Home} />
                        <AuthRouter path="/box" component={Box} />
                        <AuthRouter path="/task" component={Task} />
                        <AuthRouter path="/medal" exact component={Medal} />
                        <Route path="/chrome" exact component={Chrome} />
                        <Route path="/detection" exact component={Detection} />
                        <Route
                            path="/share-guide"
                            exact
                            component={ShareGuide}
                        />
                        <Route
                            path="/medal-guide"
                            exact
                            component={ShareGuide}
                        />
                    </Switch>
                    <Loading />
                </Provider>
            </Router>
        );
    }
}

export default App;
